import { render, staticRenderFns } from "./EditPermissionDialog.vue?vue&type=template&id=e4d9fa70"
import script from "./EditPermissionDialog.vue?vue&type=script&lang=js"
export * from "./EditPermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports